var map = {
	"./stopwatch_background_image1.svg": "./src/assets/images/camstudy/stopwatch_background_image1.svg",
	"./stopwatch_background_image2.svg": "./src/assets/images/camstudy/stopwatch_background_image2.svg",
	"./stopwatch_background_image3.svg": "./src/assets/images/camstudy/stopwatch_background_image3.svg",
	"./stopwatch_background_image4.svg": "./src/assets/images/camstudy/stopwatch_background_image4.svg",
	"./stopwatch_background_image5.svg": "./src/assets/images/camstudy/stopwatch_background_image5.svg",
	"./stopwatch_background_image6.svg": "./src/assets/images/camstudy/stopwatch_background_image6.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/camstudy sync recursive ^\\.\\/stopwatch_background_.*\\.svg$";